import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper'
import styles from './styles.module.scss'
import parse from "html-react-parser"
import { runningString } from '../../../routes/runningString'

const RunningString = () => {
	const onBeforeInit = (swiper) => {
		// eslint-disable-next-line no-undef
		if(swiper.el) {
			let swiperItems = swiper.el.querySelectorAll('.swiper-slide')
			swiperItems.forEach(el => el.style.maxWidth = el.offsetWidth)
		}
		swiper.update()
	};

	return (
		<div className={styles.wrapper}>
			<Swiper
				className={styles.list}
				modules={[Autoplay]}
				spaceBetween={10}
				initialSlide={0}
				slidesPerView={'auto'}
				centeredSlides={true}
				slidesPerGroup={runningString.length}
				speed={5000*runningString.length}
				loop={true}
				autoplay={{
					delay: 0,
					disableOnInteraction: false,
				}}
				onBeforeInit={onBeforeInit}
				onInit={onBeforeInit}
				breakpoints={{
					1440: {
						spaceBetween: 25
					},
					1024: {
						spaceBetween: 20
					},
					768: {
						spaceBetween: 15
					},
					480: {
						spaceBetween: 15
					}
				}}
			>
				{runningString.map(item => (
					<SwiperSlide key={item.id} className={styles.item}>
						<span className={styles.item_title}>{item.title}</span>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	)
}

export default RunningString